import React from "react";
import { sumarFecha } from "../../../utils/Tools";

const HotelSection = (props) => {
  const { producto, charter } = props;
  const fechaIn = sumarFecha(
    charter.fechaSalida,
    producto.diaAdicional
  );
  const fechaOut = sumarFecha(
    charter.fechaSalida,
    Number(producto.diaAdicional) + Number(producto.noches)
  );

  return (
    <div className="card hotel">
      <div className="card-header" id="headingTwo">
        <h5>
          <button
            className="btn btn-link"
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="true"
            aria-controls="collapseTwo"
          >
            Hotel
            <i className="material-icons">keyboard_arrow_up</i>
          </button>
        </h5>
      </div>
      <div
        id="collapseTwo"
        className="collapse accordion-info show"
        aria-labelledby="headingTwo"
        data-parent="#accordion"
      >
        <div className="card-body">
          <h4>Hotel {producto.notaAlojamiento}</h4>
          <ul className="hoteles form-row">
            <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
              <h6>
                <strong>Ingreso:</strong>
              </h6>
            </li>
            <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
              <h6>{fechaIn}</h6>
            </li>
            <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
              <h6>
                <strong>Salida:</strong>
              </h6>
            </li>
            <li className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
              <h6>{fechaOut}</h6>
            </li>
          </ul>
          <h4>{producto.regimen.descripcion}</h4>
        </div>
      </div>
    </div>
  );
};

export default HotelSection;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/FichaReserva/hotelSection.js